import { useQuery } from 'react-query';
import ValidationAPI from '../Api/validation';

// eslint-disable-next-line import/prefer-default-export
export const useGet2faMethods = () =>
  useQuery({
    queryFn: () => ValidationAPI.get2faMethods(),
    cacheTime: 0,
  });
